<template>
  <UIDialog :is-open :title :z-index size="sm" @close="handleClose">
    <CashflowProjectionForm :instance="modal.entity" @close="handleClose" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { CashFlowProjectionClass } from '..'
import { ModalClass } from '@types'

import { CASHFLOW_PROJECTION_MODAL_TITLE, CASHFLOW_PROJECTION_MODAL_TITLE_NEW } from './utils/const'

import { UIDialog } from '@ui/modals'
import CashflowProjectionForm from './CashflowProjectionForm.vue'

type Props = {
  modal: ModalClass<CashFlowProjectionClass>
}

const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? CASHFLOW_PROJECTION_MODAL_TITLE_NEW : CASHFLOW_PROJECTION_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)

const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}
</script>
